import { render, staticRenderFns } from "./AppRelatedSmallSection.vue?vue&type=template&id=2f8390da&scoped=true&"
import script from "./AppRelatedSmallSection.vue?vue&type=script&lang=js&"
export * from "./AppRelatedSmallSection.vue?vue&type=script&lang=js&"
import style0 from "./AppRelatedSmallSection.vue?vue&type=style&index=0&id=2f8390da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8390da",
  null
  
)

export default component.exports